module.exports = __webpack_public_path__ + "img/head-img.08803b0d.png";